import { useEffect } from 'react';

function upsertMeta(selector, attributes) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement('meta');
    document.head.appendChild(node);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    if (value == null) return;
    node.setAttribute(key, value);
  });
  return node;
}

function upsertLink(rel, href) {
  let node = document.head.querySelector(`link[rel="${rel}"]`);
  if (!node) {
    node = document.createElement('link');
    node.setAttribute('rel', rel);
    document.head.appendChild(node);
  }
  node.setAttribute('href', href);
}

export function useReportHeadMeta(meta) {
  useEffect(() => {
    if (!meta) return undefined;

    document.title = meta.title;
    document.documentElement.lang = meta.lang || 'en';

    upsertMeta('meta[name="description"]', {
      name: 'description',
      content: meta.description,
    });
    upsertMeta('meta[property="og:type"]', {
      property: 'og:type',
      content: 'article',
    });
    upsertMeta('meta[property="og:locale"]', {
      property: 'og:locale',
      content: meta.locale || 'en_US',
    });
    upsertMeta('meta[property="og:site_name"]', {
      property: 'og:site_name',
      content: meta.siteName,
    });
    upsertMeta('meta[property="og:title"]', {
      property: 'og:title',
      content: meta.title,
    });
    upsertMeta('meta[property="og:description"]', {
      property: 'og:description',
      content: meta.description,
    });
    upsertMeta('meta[property="og:url"]', {
      property: 'og:url',
      content: meta.pageUrl,
    });
    upsertMeta('meta[property="og:image"]', {
      property: 'og:image',
      content: meta.image,
    });
    upsertMeta('meta[property="og:image:alt"]', {
      property: 'og:image:alt',
      content: meta.title,
    });
    upsertMeta('meta[name="twitter:card"]', {
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    upsertMeta('meta[name="twitter:title"]', {
      name: 'twitter:title',
      content: meta.title,
    });
    upsertMeta('meta[name="twitter:description"]', {
      name: 'twitter:description',
      content: meta.description,
    });
    upsertMeta('meta[name="twitter:image"]', {
      name: 'twitter:image',
      content: meta.image,
    });
    upsertLink('canonical', meta.pageUrl);

    return undefined;
  }, [meta]);
}
